import { Pipe, PipeTransform } from '@angular/core';
import { Offer } from './model/Offer';
import { InsurerEnum } from './model/enums/InsurerEnum';

@Pipe({
  name: 'availablePremiums',
  pure: true
})
export class AvailablePremiumsPipe implements PipeTransform {

  transform(premiums: Offer[], selectedInsurer: InsurerEnum): Offer[] {
    if (!premiums) {
      return [];
    }

    if (premiums.length === 0 || !selectedInsurer) {
      return premiums;
    }

    return premiums.filter(premium => premium.insurer !== selectedInsurer);
  }

}

